import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalenderAdd"><Path d="M20.5 8.5H3.5M20.5 8.5V4.5H3.5V8.5M20.5 8.5V12.5M3.5 8.5V20.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 15.5V18.5M18.5 18.5V21.5M18.5 18.5H15.5M18.5 18.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalenderAdd;
